
import * as React from "react";
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
  FormDescription,
} from "@/components/ui/form";
import { Textarea } from "@/components/ui/textarea";
import { UseFormReturn } from "react-hook-form";

interface FormTextareaProps {
  form: UseFormReturn<Record<string, unknown>>;
  name: string;
  label: string;
  description?: string;
  placeholder?: string;
  maxLength?: number;
  showCount?: boolean;
  required?: boolean;
}

export function FormTextarea({
  form,
  name,
  label,
  description,
  placeholder,
  maxLength,
  showCount = false,
  required = false,
}: FormTextareaProps) {
  const characterCount = (form.watch(name) as string)?.length || 0;

  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{label} {required && <span className="text-red-500">*</span>}</FormLabel>
          {description && <FormDescription>{description}</FormDescription>}
          <FormControl>
            <div className="relative">
              <Textarea 
                placeholder={placeholder}
                className={`min-h-[100px] ${form.formState.errors[name] ? "border-destructive" : ""}`}
                maxLength={maxLength}
                {...field}
                value={field.value as string}
              />
              {showCount && maxLength && (
                <div className="absolute bottom-2 right-2 text-xs text-muted-foreground">
                  {characterCount}/{maxLength}
                </div>
              )}
            </div>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
